import { useQuery } from '@tanstack/react-query';

import { dashboardV2Client } from '../api/client';
import { dashboardV2QueryKeys } from '../api/queryKeys';
import { NoShowData } from '../api/types';

// Outstanding no-show worker instances grouped by shift. Kept lightly fresh so
// the queue reflects new no-shows / resolutions without a manual reload.
const useNoShowQueue = (agencyId: number) =>
  useQuery<NoShowData>({
    queryKey: dashboardV2QueryKeys.noShow(agencyId),
    queryFn: () => dashboardV2Client.getNoShow(agencyId),
    enabled: agencyId != null,
    staleTime: 30_000,
  });

export default useNoShowQueue;
